import React, { useEffect } from "react";
import HeaderView from "./Views/HeaderView";
import SalaryPage from "./Salary/SalaryPage";
import OverheadsPage from "./Overheads/OverheadsPage";
import WorkingHoursPage from "./WorkingHours/WorkingHoursPage";
import KeyFiguresPage from "./KeyFigures/KeyFiguresPage";
import SiaKpisPage from "./SiaKpis/SiaKpisPage";
import NotFoundPage from "pages/Error/NotFoundPage";
import ErrorPage from "pages/Error/ErrorPage";
import AnonymounsUserView from "./Views/AnonymousUserView";
import InvalidSubscriptionView from "./Views/InvalidSubscriptionsView";
import EvaluationsMasterkeyModal from "./MasterkeyModal/EvaluationsMasterkeyModal";

export const routesMap = new Map([
  [
    "keyFigures",
    {
      url: "key-operating-figures",
      key: "key-figures",
      tabIndex: 0,
      component: KeyFiguresPage,
    },
  ],
  [
    "overhead",
    {
      url: "overhead-costs",
      key: "overheads",
      tabIndex: 1,
      component: OverheadsPage,
    },
  ],
  [
    "siaKpis",
    {
      url: "sia-kpis",
      key: "sia-kpis",
      tabIndex: 2,
      component: SiaKpisPage,
    },
  ],
  [
    "salary",
    {
      url: "wages",
      key: "salary",
      tabIndex: 3,
      component: SalaryPage,
    },
  ],

  [
    "workingHours",
    {
      url: "hours-worked",
      key: "working-hours",
      tabIndex: 4,
      component: WorkingHoursPage,
    },
  ],
]);

const getEvaluationUrl = (languageKey) => `/${languageKey}/stats`;
const getRedirectUrl = (pathname) => pathname.split("/").slice(2).join("/");
export const generateTopSectionTabs = (translate) =>
  Array.from(routesMap.values(), ({ key }) => ({ title: translate(`benchmarking.evaluations.header.view.${key}`) }));

export function usePageRefresh(currentTab, expectedTab, setSelectedTab) {
  useEffect(() => {
    if (currentTab !== expectedTab) setSelectedTab(expectedTab);
  }, [currentTab, expectedTab, setSelectedTab]);
}

export function validateLanguageKey(i18n, languageKey) {
  const languageKeys = Object.keys(i18n.options.resources);
  return languageKeys.includes(languageKey);
}

export function generateViewWithHeader(languageKey, translate, selectedTab, setSelectedTab, history, component) {
  return (
    <div>
      <HeaderView
        tabs={generateTopSectionTabs(translate)}
        history={history}
        selectedTab={selectedTab}
        setSelectedTab={(index) => {
          if (index === selectedTab) return;
          const route = Array.from(routesMap.values()).find((item) => item.tabIndex === index);
          setSelectedTab(index);
          history.push(`${getEvaluationUrl(languageKey)}/${route.url}`);
        }}
      />
      {component}
    </div>
  );
}

export function generateMiddleWare(
  i18n,
  languageKey,
  user,
  translate,
  selectedTab,
  setSelectedTab,
  history,
  masterKeyAccess,
  options = { withHeader: true }
) {
  return function middleWare(component) {
    if (!validateLanguageKey(i18n, languageKey)) return <NotFoundPage />;
    if (!user) return <AnonymounsUserView />;
    if (!user.getRole()?.includes("bm_output_role")) return <InvalidSubscriptionView />;
    if (masterKeyAccess.error) return <ErrorPage />;
    if (masterKeyAccess.shouldPrompt) {
      return (
        <>
          <AnonymounsUserView />
          <EvaluationsMasterkeyModal
            translate={translate}
            redirectUrl={getRedirectUrl(window.location.pathname)}
            onAuthenticated={masterKeyAccess.markAuthenticated}
            onContinueWithoutKey={masterKeyAccess.continueWithoutKey}
          />
        </>
      );
    }
    if (!masterKeyAccess.canFetch) return null;
    return (
      <div className="sia-stats-header-container">
        {options.withHeader ? generateViewWithHeader(languageKey, translate, selectedTab, setSelectedTab, history, component) : component}
      </div>
    );
  };
}
